<template>
  <div>
    <div class="contact-item" @click="handeItemClick">
      <span class="contact-item-icon">
        <i :class="open ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
      </span>
      <div>{{ title }}</div>
    </div>
    <div style="max-height: 510px; overflow-y: auto">
      <contact-item v-for="(contact, index) in imQyhContactData" v-if="contact.im_accid !== imAccount.im_accid" :key="index" :contact="contact" :open="open" :is-active="imActiveContact.id === contact.id" @active-change="handleActiveChange" />
    </div>
  </div>
</template>

<script>
import ContactItem from './ContactItem'
import { mapState } from 'vuex'
export default {
  name: 'ContactList',
  components: { ContactItem },
  props: {
    title: '',
    contacts: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState({
      imAccount: state => state.imAccount,
      imActiveContact: state => state.imActiveContact,
      imQyhContactData: state => state.imQyhContactData,
    })
  },
  watch: {
  },
  methods: {
    handeItemClick () {
      this.open = !this.open
    },
    handleActiveChange (account) {
      this.$store.commit('changeImActiveContactMutation', { account, type: 'contact' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact-item {
  display: flex;
  font-size: 14px;
  color: #333;
  padding: 12px;
  position: relative;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 5px;
}
.contact-item-icon {
  color: #b0b0b0;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/contacts/ContactList.vue